import { ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const beforeDateValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const endDate = control.get('endDate');
  const startDate = control.get('startDate');

  return startDate.value >= endDate.value ? { startDateGreaterThanEndDate: true } : null;
};
